import React, { Component } from 'react';
// import Modal from 'react-responsive-modal';
import { Button, Input, Modal } from 'reactstrap';
import ReactStars from 'react-stars'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IoIosClose } from 'react-icons/io';
import axios from 'axios';
import * as vars from '../../constants/constants';
import { FormattedMessage } from 'react-intl';
import { config } from "../../constants/domainConfig";
import Feedbackicon from './Feedback-icon.png';
import Tilt from 'react-tilt'

class Feedback extends Component {

    constructor(props) {
        super(props)
        this.state = {
            comment: '',
            overall_rating: 0.0,
            content_rating: 0.0,
            etn_rating: 0.0,
            reliability_rating: 0.0,
            success: false,
            open: false,
        }
        this.ratingChanged = this.ratingChanged.bind(this);
        this.handleComment = this.handleComment.bind(this);
        this.handleAddFeedbackData = this.handleAddFeedbackData.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.feedbackModalToggle = this.feedbackModalToggle.bind(this);
    }
    ratingChanged(newRating, rated) {
        if (rated === "overall_rating") {
            this.setState({
                overall_rating: newRating
            })
        } else if (rated === "content_rating") {
            this.setState({
                content_rating: newRating
            })
        } else if (rated === "etn_rating") {
            this.setState({
                etn_rating: newRating
            })
        } else if (rated === "reliability_rating") {
            this.setState({
                reliability_rating: newRating
            })
        }
    }
    handleComment(e) {
        this.setState({
            comment: e.target.value
        })
    }
    componentDidMount() {
        axios.get(vars.BASE_API_URL + "/getfeedback")
            .then((response) => {
                const data = response.data.data[0];
                this.setState({
                    overall_rating: data.overall_rating,
                    content_rating: data.content_rating,
                    etn_rating: data.etn_ratin,
                    reliability_rating: data.reliability_rating,
                    comment: data.comment
                })
            })
            .catch((error) => {
                console.log(error);
            });
    }
    handleAddFeedbackData() {
        const { overall_rating, content_rating, etn_rating, reliability_rating, comment } = this.state;
        const data = {
            overall_rating,
            content_rating,
            etn_rating,
            reliability_rating,
            comment
        }
        axios.post(vars.BASE_API_URL + "/addfeedback", data)
            .then((response) => {
                const data = response.data.data;
                this.setState({
                    overall_rating: data.overall_rating,
                    content_rating: data.content_rating,
                    etn_rating: data.etn_rating,
                    reliability_rating: data.reliability_rating,
                    comment: data.comment,
                    success: true
                }, () => {
                    setTimeout(() => {
                        this.feedbackModalToggle()
                    }, 1000)
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }
    feedbackModalToggle() {
        this.setState({
            success: false
        })
        this.props.feedbackModalToggle();
    }

    onCloseModal() {
        this.setState({ open: false });
    };

    render() {
        const { feedbackModal } = this.props;
        const feedbackPlaceholder = {
            en: "Please enter your comments or suggestions.",
            no: "Skriv inn kommentar med forslag",
            fr: "S'il vous plaît entrer vos commentaires ou suggestions.",
            el: "Παρακαλούμε εισάγετε τα σχόλια των προτάσεών σας",
            id: "Silakan masukkan komentar atau saran Anda."
        }

        const { overall_rating, content_rating, etn_rating, reliability_rating, comment, success } = this.state;
        return (
            <Modal isOpen={feedbackModal} toggle={this.feedbackModalToggle} className="feedbackModal">

                {success ?
                    <div className="feedback-success">
                        <h4><b>
                            <FormattedMessage id="feedbackWasSent"
                                defaultMessage="Feedback was sent!"
                            />
                        </b></h4>
                    </div>
                    :
                    <div className="col-md-12">
                        <div className="col-md-6 float-left">

                            <Tilt className="Tilt" options={{ max: 25 }} style={{ reset: true }} >
                                <img src={Feedbackicon} className="img-responsive feedback-icon-thumbup" />
                            </Tilt>
                        </div>

                        <div className="col-md-6 float-right">
                            <h3 className="feedback-star-heading">

                                <FormattedMessage id="feedback"
                                    defaultMessage="FEEDBACK"
                                />
                                <span className="feedback-cancel-icon" >
                                    <IoIosClose onClick={this.feedbackModalToggle} size={25} />
                                </span>
                            </h3>

                            <p className="feedback-star-body">
                                <FormattedMessage id="weWouldBe"
                                    defaultMessage="We would be very grateful if you could spare a few minutes to help us improve our website by completing this short survey- your feedback is very much appreciated."
                                /></p>

                            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                <div className="rating-star-container">
                                    <div className="feedback-star-title">
                                        <b>
                                            <FormattedMessage id="overall"
                                                defaultMessage="Overall:"
                                            />
                                        </b>
                                    </div>
                                    <div className="feedback-star-container">
                                        <ReactStars value={overall_rating} count={5} size={30} color2={'#ffd700'} onChange={(e) => this.ratingChanged(e, "overall_rating")} />
                                    </div>
                                </div>
                                <div className="rating-star-container">
                                    <div className="feedback-star-title">
                                        <b>
                                            <FormattedMessage id="content"
                                                defaultMessage="Content:"
                                            />
                                        </b>
                                    </div>
                                    <div className="feedback-star-container">
                                        <ReactStars value={content_rating} count={5} size={30} color2={'#ffd700'} onChange={(e) => this.ratingChanged(e, "content_rating")} />
                                    </div>
                                </div>
                                <div className="rating-star-container">
                                    <div className="feedback-star-title">
                                        <b>
                                            <FormattedMessage id="easyTo"
                                                defaultMessage="Easy to navigate:"
                                            />
                                        </b>
                                    </div>
                                    <div className="feedback-star-container">
                                        <ReactStars value={etn_rating} count={5} size={30} color2={'#ffd700'} onChange={(e) => this.ratingChanged(e, "etn_rating")} />
                                    </div>
                                </div>
                                <div className="rating-star-container">
                                    <div className="feedback-star-title">
                                        <b>
                                            <FormattedMessage id="site"
                                                defaultMessage="Site reliability:"
                                            />
                                        </b>
                                    </div>
                                    <div className="feedback-star-container">
                                        <ReactStars value={reliability_rating} count={5} size={30} color2={'#ffd700'} onChange={(e) => this.ratingChanged(e, "reliability_rating")} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">

                                <textarea placeholder={feedbackPlaceholder[config.lang] ? feedbackPlaceholder[config.lang] : feedbackPlaceholder.en} onChange={this.handleComment} value={comment} name="text" id="exampleText" className={"comment-textarea form-control"} />
                            </div>

                            <Button style={{ border:'none',width: "100%", backgroundColor: "#d51a92 ", marginTop: '2%', color: "#fff", borderRadius: "20px", fontSize: "20px", fontWeight: "bolder" }} onClick={this.handleAddFeedbackData}>
                                <FormattedMessage id="submit"
                                    defaultMessage="Submit"
                                />
                            </Button>

                        </div>

                    </div>}
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {

    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({

    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);


// WEBPACK FOOTER //
// ./src/components/feedback/feedback.js